<template>
  <b-modal scrollable v-model="showModal">
    <div slot="modal-title">
      {{ $t('message.promo_code.my_vouchers') }}
    </div>
    <section>
      <div class="row no-gutters mb-4">
        <div class="col-10 pr-2">
          <input type="search"
                 class="form-control"
                 :placeholder="$t('message.promo_code.add_code')"
                 v-model="keyword">
        </div>
        <div class="col-2 text-right">
          <button class="btn btn-info px-3" @click="performSearchPromoCode()">
            {{ $t('message.button.add_code') }}
          </button>
        </div>
        <div class="py-2" v-if="hasPromoCode === false">
          <i class="fa fa-times -status-alert"></i> <span
          class="text-secondary">{{ $t('message.alert.no_promo_code') }}</span>
        </div>
      </div>
      <section v-if="promoCodes">
        <div v-for="(promoCode, index) in promoCodes">
          <div class="card shadow-sm" role="button" @click="selectPromoCode(promoCode)" :key="index">
            <div class="card-body">
              <div class="d-flex justify-content-start align-items-center">
                <div>
                  <img :src="promoCode.image_url" alt="" class="rounded-circle" width="40">
                </div>
                <div class="flex-fill pl-3">
                  <h4 class="mb-0">{{ promoCode.title }}</h4>
                </div>
                <div class="text-right">
                  <div class="border border-light rounded -bg-promo-code-count text-small px-2 py-1">
                    <span v-if="promoCode.disabled">{{ $t('message.promo_code.not_available') }}</span>
                    <span v-else-if="!promoCode.disabled && getRemainingCount(promoCode)">
                      {{ getRemainingCount(promoCode) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="pt-2" v-if="promoCode.province_id || promoCode.service_id">
                <div class="d-inline-block border border-info rounded text-small text-info px-2"
                     :class="{'-status-alert border-danger text-danger' : promoCode.disabled}"
                     v-if="promoCode.service_id && globalState.services[promoCode.service_id]"
                     v-html="$options.filters.serviceParentName(promoCode.service_id, globalState.services)"></div>
                <div class="d-inline-block border border-orange rounded text-small text-orange px-2"
                     :class="{'-status-alert border-danger text-danger' : promoCode.disabled}"
                     v-if="promoCode.province_id">
                  {{ globalState.cities[promoCode.province_id] | multiLangName }}
                </div>
              </div>
              <div class="pt-2 pb-2"
                   :class="{'-status-offline' : promoCode.disabled}">
                <h3 class="mb-0" v-if="promoCode.discount_type === 'amount'">
                  {{ (promoCode.discount_amount > 0) ? $t('message.promo_code.title_amount', { num: promoCode.discount_amount }) : promoCode.description }}
                </h3>
                <h3 class="mb-0" v-else>
                  {{ (promoCode.discount > 0) ? $t('message.promo_code.title', { num: promoCode.discount }) : promoCode.description }}
                </h3>
              </div>
              <div class="pt-1 text-small"
                   :class="{'-status-alert' : promoCode.disabled}"
                   v-if="promoCode.discount > 0 || promoCode.discount_amount > 0">
                {{ ($i18n.locale === 'th') ? promoCode.payment_method_th : promoCode.payment_method_en }}
              </div>
              <div class="pt-1 -status-alert text-small"
                   v-if="promoCode.remark">
                {{ promoCode.remark }}
              </div>
              <div class="pt-1 -status-offline text-small">{{ $t('message.promo_code.expiring') }}:
                <span>{{ promoCode.expire_date | prettyOnlyDate }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-center text-secondary p-4" v-else>
        <div class="mb-3"><i class="fal fa-ticket fa-3x"></i></div>
        <h4>{{ $t('message.promo_code.no_promo_codes') }}</h4>
      </section>

    </section>
    <div slot="modal-footer" class="w-100">
      <b-btn class="float-right" variant="secondary" @click="showModal = false">
        {{ $t('message.button.close') }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    props: {
      searchParams: Object
    },
    data () {
      return {
        showModal: false,
        keyword: null
      }
    },
    computed: {
      ...mapState('promoCode', ['promoCodes', 'hasPromoCode']),
      ...mapState('chatBooking', ['partner']),
      ...mapState('booking', ['preCheckoutData']),
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      keyword () {
        if (!this.keyword) {
          this.$store.commit('promoCode/SET_HAS_PROMO_CODE', null)
        }
      },
      hasPromoCode () {
        if (this.hasPromoCode) {
          this.keyword = null
        }
      }
    },
    methods: {
      ...mapActions('promoCode', ['fetchPromoCodes', 'searchPromoCode']),
      async showMyPromoCodeModal (status) {
        this.showModal = status
        if (status && this.user) {
          const queryParams = {
            user_id: this.user.id
          }
          // Check partner and ref code of partner
          if (this.partner && this.$route.query.ref) {
            queryParams.partner_id = this.partner.id
          }
          if (this.preCheckoutData) {
            queryParams.payment_method = this.preCheckoutData.payment_method
            if (this.preCheckoutData.omise_customer_id) {
              queryParams.omise_customer_id = this.preCheckoutData.omise_customer_id
            }
            if (this.preCheckoutData.parent_service_id) {
              queryParams.service_id = this.preCheckoutData.parent_service_id
            }
          }
          await this.fetchPromoCodes(queryParams)
          // Clear search promo code
          this.keyword = null
          this.$store.commit('promoCode/SET_HAS_PROMO_CODE', null)
        }
      },
      getRemainingCount (promoCode) {
        let result = null
        let count = 0
        let maxQty = 0
        if (promoCode.is_one_time_code === 1) {
          count = 1
          maxQty = 1
        } else if (promoCode.limit_per_user > 0) {
          count = promoCode.limit_per_user - promoCode.applied_count
          maxQty = promoCode.limit_per_user
        }
        if (count > 0) {
          result = `${count}/${maxQty}`
        }
        return result
      },
      selectPromoCode (promoCode) {
        if (!promoCode.disabled) {
          this.$emit('onSelected', promoCode)
          this.showMyPromoCodeModal(false)
        }
      },
      async performSearchPromoCode () {
        if (this.keyword && this.searchParams && this.user) {
          const submitData = {
            user_id: this.user.id,
            promo_code: this.keyword,
            province_id: this.searchParams.province_id,
            service_id: this.searchParams.service_id,
            work_hour: this.searchParams.work_hour
          }
          if (this.partner) {
            submitData.partner_id = this.partner.id
          }
          await this.searchPromoCode(submitData)
        }
      }
    }
  }
</script>

<style scoped>
  .bg-promotion {
    background-size: cover;
    background-position: center;
    width: 100px;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/booking/components/MyPromoCodeModal.vue